import * as actionType from './actionTypes';

export function setSalesOrder(salesOrder:[]) {
  return {
    type: actionType.SET_SALES_ORDER,
    payload: salesOrder,
  }
}

export function appendSalesOrder(salesOrder:[]) {
  return {
    type: actionType.APPEND_SALES_ORDER,
    payload: salesOrder,
  }
}

export function setNoMoreSalesOrder(noMoreSalesOrder: boolean) {
  return {
    type: actionType.SET_NO_MORE_SALES_ORDER,
    payload: noMoreSalesOrder,
  }
}

export function setSalesOrderFilters(salesOrderFilters:{}) {
  return {
    type: actionType.SET_SALES_ORDER_FILTERS,
    payload: salesOrderFilters,
  }
}

export function setSalesOrderNotifications(salesOrder:{}[]) {
  return {
    type: actionType.SET_SALES_ORDER_NOTIFICATIONS,
    payload: salesOrder,
  }
}

export function setSalesOrderState(state:string) {
  return {
    type: actionType.SET_SALES_ORDER_STATE,
    payload: state,
  }
}

export function setNotificationAsRead(event:{}) {
  return {
    type: actionType.SET_NOTIFICATION_AS_READ,
    payload: event,
  }
}

export function setReadSalesOrderNotifications(salesOrder:{}[]) {
  return {
    type: actionType.SET_READ_SALES_ORDER_NOTIFICATIONS,
    payload: salesOrder,
  }
}
